export default __webpack_public_path__ + "static/media/PlaceCropsInFigure.43cf2b30.gif";